import { AppointmentWUT } from '@wix/form-fields/wut';

export default AppointmentWUT;
